import { useI18n } from '../i18n/I18nProvider';
import { Star } from './icons';

/** Средний балл звёздами. Без оценок — текст, а не «0.0»: ноль читался бы как худшая оценка. */
export function RatingLine(props: { sum: number; count: number }): JSX.Element {
  const { t } = useI18n();
  if (props.count === 0) {
    return <div className="py-1 text-[13px] leading-[1.5] text-ink-3">{t('statsNoRating')}</div>;
  }
  const avg = props.sum / props.count;
  return (
    <div className="flex items-center gap-3 py-1">
      <div className="text-[28px] font-extrabold tracking-[-0.02em]">{avg.toFixed(1)}</div>
      <div>
        <Stars value={avg} />
        <div className="mt-0.5 text-[12px] text-ink-3">
          {props.count} {t('statsRatingCount')}
        </div>
      </div>
    </div>
  );
}

/**
 * Пять звёзд. С `onPick` — это ввод оценки (каждая звезда — кнопка), без него — показ.
 */
export function Stars(props: { value: number; size?: number; onPick?: (stars: number) => void }): JSX.Element {
  const size = props.size ?? 16;
  if (props.onPick) {
    const pick = props.onPick;
    return (
      <div className="flex gap-1 text-accent">
        {[1, 2, 3, 4, 5].map((n) => (
          <button key={n} type="button" aria-label={String(n)} onClick={() => pick(n)} className="p-0.5">
            <Star size={size} strokeWidth={1.75} />
          </button>
        ))}
      </div>
    );
  }
  return (
    <div className="flex gap-0.5 text-accent" aria-label={props.value.toFixed(1)}>
      {[1, 2, 3, 4, 5].map((n) => (
        <Star
          key={n}
          size={size}
          strokeWidth={1.75}
          fill={props.value >= n - 0.25 ? 'currentColor' : 'none'}
          className={props.value >= n - 0.75 ? '' : 'text-ink-3'}
        />
      ))}
    </div>
  );
}

/** Компактный бейдж «★ 4.8 (12)» для каталога и страницы заведения. Без оценок не рисуется. */
export function RatingBadge(props: { sum: number; count: number }): JSX.Element | null {
  if (props.count === 0) return null;
  return (
    <span className="inline-flex items-center gap-1 text-[12.5px] font-bold text-ink">
      <Star size={13} strokeWidth={1.75} fill="currentColor" className="text-accent" aria-hidden="true" />
      {(props.sum / props.count).toFixed(1)}
      <span className="font-medium text-ink-3">({props.count})</span>
    </span>
  );
}
